import Actor from "../../actors/Actor";

export default class Timer extends Actor {
    constructor() {
        super();
        this.view = new PIXI.spine.Spine(P3.assets.spineData('timer'));
        this.view.position.set(0, 50);
        this.view.scale.set(0.5);
        this.view.skeleton.setToSetupPose();
        this.view.skeleton.setSkin(null);
        this.view.skeleton.setSkinByName("default");
        this.view.autoUpdate = false;
        this.view.update(0);
        this.addChild(this.view);
        this.view.stateData.defaultMix = 0.2;

        this.view.state.addListener({
            complete: this._onAnimationComplete.bind(this),
            event: this._onAnimationEvent.bind(this)
        });

        this._finished = new P3.utils.MiniSignal();

        this._sound = null;
        this._isPlaying = false;
        this._timeTracker = 0;
    }

    update(dt) {
        this.view.update(dt);

        if(this._isPlaying){
            this._timeTracker += dt;
            if(this._timeTracker > 3.2){
                P3.audio.playSound('sfx_oven_timer_ping_00');
                this._timeTracker = null;
            }
        }

    }

    playTimer(){
        this.view.state.addAnimation(0, "timer", false, 0);
        this._sound = P3.audio.playSound('sfx_over_timer_loop_00', {loop:true});
        this._isPlaying = true;
    }

    _onAnimationComplete(entry) {
        const name = entry.animation.name;
        if (["timer"].indexOf(name) !== -1) {
            this._finished.dispatch();
            this._sound.stop();
            //P3.audio.playSound('sfx_oven_timer_ping_00');
            this._isPlaying = false;
        }
    }

    _onAnimationEvent(entry, event) {
        //console.log(entry);
    }
}